import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, { Component } from 'react';


export class MainMenuItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }


    render() {
        let { text, onClick } = this.props;

        return (
            <ListItem>
                <ListItemText>
                    <div
                        className='sidebarMenuText'
                        onClick={onClick}>
                        {text}
                    </div>
                </ListItemText>
            </ListItem>
        );
    }
}